import Styled from 'styled-components';

const FilterTagWrapper = Styled.div`
  display: flex;
  padding: 10px 15px;
  align-items: center;
  justify-content: flex-start;
  border-left: 1px solid #E9E9E9;
  border-right: 1px solid #E9E9E9;
  border-bottom: 1px solid #E9E9E9;
  overflow: scroll;
`;

export { FilterTagWrapper };
